export const handleSelectSchedule = function (locale, schedule) {
    // Initializing switchTo in the state + redirect to 'verification-du-panier'
    this.props.switchToInit({
        locale: { ...locale, currentSchedule: schedule },
        schedule: schedule,
        globalOrder: schedule.globalOrder
    })

}
